export type DatabaseItemType =
    "None"
    | "Documents"
    | "RevisionDocuments"
    | "Indexes"
    | "Identities"
    | "Tombstones"
    | "LegacyAttachments"
    | "Conflicts"
    | "CompareExchange"
    | "LegacyDocumentDeletions"
    | "LegacyAttachmentDeletions"
    | "DatabaseRecord"
    | "Unknown"
    | "Attachments"
    | "CounterGroups"
    | "Subscriptions"
    | "CompareExchangeTombstones"
    | "TimeSeries"
    | "ReplicationHubCertificates";